export const CRITICAL_ILLNESS = {
  nickname: 'PRODUCTS.CRITICAL_ILLNESS.nickname',
  lifeInsurance: true,
  icon:'critical-illness'
};
